(function ($) {
  Drupal.behaviors.productGallery = {
    attach: function (context) {
      var $howToUse = $('.js-responsive-tabs--how_to_use', context);

      if ($howToUse.length > 0) {
        $howToUse.easyResponsiveTabs();
        // Set Tab header Position when Tab container Scroll
        tabScrollTop();
        Unison.on('change', function (bp) {
          setTimeout(function () {
            tabScrollTop();
          }, 200);
        });

        function tabScrollTop() {
          var $isMobile = Unison.fetch.now().name === 'small';

          if ($isMobile) {
            $howToUse.on('tabactivate', function (e, currentTab) {
              if (currentTab) {
                var $docScrollTop = $(window).scrollTop();
                var $parentScrollTop = currentTab.offsetParent.offsetTop;

                if ($docScrollTop > $parentScrollTop) {
                  $('html, body').animate(
                    {
                      scrollTop: $parentScrollTop
                    },
                    300
                  );
                }
              }
            });
          }
        }
      }
    }
  };
})(jQuery);
